import { useContext } from 'react';
import './CardTwo.scss';
import { CurrentLangContext, LangContext } from '../../../contexts/contexts';

function CardTwo() {
  const langs = useContext(LangContext);
  const cardTwoLangs = langs.buy;

  const CurrentLangC = useContext(CurrentLangContext);
  const currentLang = CurrentLangC[0];

  return (
    <section className="CardTwo">
      <div className="CardTwo_img"></div>
      <div className="CardTwo_text">
        <div className="cardTwo_title">
        <p>20 000{currentLang === "fr" ? "€" : "$"}</p>
          <p>{cardTwoLangs.land[currentLang]}</p>
        </div>
        <div className="cardTwo_paragraph">
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        </div>
      </div>
      <button>{cardTwoLangs.view[currentLang]}</button>
    </section>
  );
}

export default CardTwo;